module.exports = __webpack_public_path__ + "img/goods5_1.e9a098d5.jpg";